<!-- frontend/src/views/LCAStepperView.vue -->
<template>
  <div class="lca-stepper-view">
    <!-- Header Component -->
    <Header />

    <!-- Main Content Area -->
    <main class="main-content">
      <LCAStepper />
    </main>

    <!-- Footer Component -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import LCAStepper from '@/components/LCA/Stepper/LCAStepper.vue';

export default {
  name: 'LCAStepperView',
  components: {
    Header,
    Footer,
    LCAStepper,
  },
};
</script>

<style scoped>
.lca-stepper-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f2f5e7;
}

.main-content {
  flex: 1;
  padding-top: 100px; /* Space for the fixed Header */
  width: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f2f5e7 100%);
  padding-bottom: 3rem;
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 80px;
  }
}
</style>